// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__fBqPg","selects":"Documents_selects__21LxN"};